const microsftDomains = ["msn", "hotmail", "outlook", "live"];

export const isValidEmail = (email) => {
  var emailSplitted = email.split('@');

  if(emailSplitted.length != 2) return false;

  var localPart = emailSplitted[0];
  var domain = emailSplitted[1];

  var localPartRegex = GetLocalPartRegexByDomain(domain);

  var domainRegex = new RegExp('^[a-z\\d](?:[a-z\\d-]{0,61}[a-z\\d])?(?:\\.[a-z\\d](?:[a-z\\d-]{0,61}[a-z\\d])?)+$', 'i');

  const isEmail = localPartRegex.test(localPart) && domainRegex.test(domain);

  return isEmail;
};

export const isValidPassword = (password) => {
  if(password.toLowerCase().includes('goalsetter')){
    return false;
  }

  // Passwords must be 8 digits and contain one capital letter and one number
  // const pattern = /^(?=.*[A-Za-z])(?=.*[A-Z])(?=.*\d)([A-Za-z\d]){6,}$/;
  const pattern = /(?=.*[A-Za-z])(?=.*[A-Z])(?=.*\W)[A-Za-z\d](.){7,}/;

  return pattern.test(password);
};

export const isValidURL = (str) => {
  const pattern = new RegExp('^(https?:\\/\\/)?' // protocol
    + '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|' // domain name
    + '((\\d{1,3}\\.){3}\\d{1,3}))' // OR ip (v4) address
    + '(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*' // port and path
    + '(\\?[;&a-z\\d%_.~+=-]*)?' // query string
    + '(\\#[-a-z\\d_]*)?$', 'i'); // fragment locator
  return !!pattern.test(str);
};

function GetLocalPartRegexByDomain(domain){
  var domainSplitted = domain.split('.');
  var host = domainSplitted[0];

  if(microsftDomains.some(x => host == x)){
    return new RegExp('^\\w[\\-\\w]*(?:\\.[\\-\\w]+)*$', 'i');
  }
  else {
    return new RegExp('^[\\p{L}\\p{N}\\-](?:[\\.\\+\\\p{L}\\p{N}_&#\'\/\-]*[\\p{L}\\p{N}_\\-])?$', 'gu');
  }
}